// import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '@env/environment';
import { throwIfAlreadyLoaded } from './module-import-guard';
//
// Utils lib
//
import { LoggerService } from 'utils';
var ɵ0 = environment.defaultLanguage;
var CoreModule = /** @class */ (function () {
    function CoreModule(parentModule, translate, logger) {
        this.translate = translate;
        this.logger = logger;
        this.logger.info('Core Module initialised');
        // 'en-GB' -> 'en'
        var defaultLanguage = environment.defaultLanguage.split('-')[0];
        this.logger.info('Default Language: ' + defaultLanguage);
        this.logger.info('Local: ' + environment.defaultLanguage.split('-')[1]);
        translate.setDefaultLang(defaultLanguage);
        translate.use(defaultLanguage);
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
    return CoreModule;
}());
export { CoreModule };
// AoT requires an exported function for factories
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}
export { ɵ0 };
// https://stackoverflow.com/questions/50860898/angular-6-services-providedin-root-vs-coremodule
